import { createSlice } from '@reduxjs/toolkit'

export const headerSlice = createSlice({
  name: "header",
  initialState: {
    pageTitle: "Home",
    noOfNotifications: 0,
    newNotificationMessage: "",
    newNotificationStatus: 1,
  },
  reducers: {
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload.title;
    },

    setNotificationCount: (state, action) => {
      state.noOfNotifications = action.payload;  // 👈 ADD THIS
    },

    removeNotificationMessage: (state) => {
      state.newNotificationMessage = "";
    },

    showNotification: (state, action) => {
      state.newNotificationMessage = action.payload.message;
      state.newNotificationStatus = action.payload.status;
    },
  },
});

export const {
  setPageTitle,
  removeNotificationMessage,
  showNotification,
  setNotificationCount,   // 👈 export it
} = headerSlice.actions;

export default headerSlice.reducer;